import React from "react";
import background from '../Pic/scratch.gif'

function Recent() {
  return (
    <>
<div className="md:row-span-3 bg-black overflow-auto rounded-2xl w-full h-full drop-shadow-lg "style={{ backgroundImage: `url(${background})`,backgroundRepeat: `no-repeat`,
  backgroundSize: `cover`,backgroundBlendMode: `screen` }} >
      <div className="bg-red-600 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly m-3 md:m-3">
        ⏱️ RECENT
      </div>
      <div
        id="carouselExampleInterval"
        class="carousel slide h-full mx-3 my-3 h-80"
        data-bs-ride="carousel"
      >
        <div class="carousel-inner  h-full w-full ">
          <div class="carousel-item active "  data-bs-interval="4000">
            <h1 className="text-white font-bold text-4xl text-left mt-4  xl:text-6xl">
              PLANET-X{" "}
            </h1>
            <p className="text-stone-400  text-left text-xl mt-4 hover:text-white md:text-2xl">
              Information about few planets from Our Solar System 🚀.{" "}
            </p>
            <div className="bg-green-600 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly mt-5 md:m-3">
              <a href="https://psantosh16.github.io/Planet-X/" className="no-underline text-white xl:p-2">EXPLORE</a>
            </div>
          </div>
          <div class="carousel-item" data-bs-interval="4000">
          <h1 className="text-white font-bold text-4xl text-left mt-3 xl:text-6xl">
              Ecommerce Store Website{" "}
            </h1>
            <p className="text-stone-400  text-left text-xl mt-4 hover:text-white md:text-2xl">
              Explore wide range of prodocts and much more 🧺.{" "}
            </p>
            <div className="bg-green-600 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly mt-5 md:m-3">
              <a href="https://psantosh16.github.io/NikeAirShop-Website/" className="no-underline text-white xl:p-2">EXPLORE</a>
            </div>
    </div>
    <div class="carousel-item">
    <h1 className="text-white font-bold text-4xl text-left mt-3 xl:text-6xl">
              Visit my Github Profile Page {" "}
            </h1>
            <p className="text-stone-400  text-left text-xl mt-4 hover:text-white md:text-2xl">
              You are only one Button away from me 🧑‍💻.{" "}
            </p>
            <div className="bg-blue-600 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly mt-5 md:m-3">
              <a href="https://github.com/psantosh16" className="no-underline text-white xl:p-2">VISIT</a>
            </div>
    </div>
        </div>
        <button
          class="carousel-control-prev "
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon visually-hidden" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next "
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon visually-hidden" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
    </>
  );
}

export default Recent;
